import { Injectable } from "@angular/core";
import { AppConfig } from "../configs/app";
import { CommonService } from "../services/common.service";
import { PlanService } from "../services/plan.service";

@Injectable({
  providedIn: "root",
})
export class CartService {
  public moment: any;
  public _: any;

  constructor(
    public appConfig: AppConfig,
    public commonService: CommonService,
    public planService: PlanService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
  }

  addToCart(cartItem: any) {
    if (cartItem) {
      let cartData: any = this.commonService.getData(
        this.appConfig.cart.cartSessionName
      );
      let serchData: any = this.commonService.getData(
        this.appConfig.cart.serchSessionName
      );

      if (cartData) {
        /* DO NOTHING */
        if (cartData.length == 0) {
          serchData = [];
        }
      } else {
        cartData = [];
        serchData = [];
      }

      if (cartData.length >= 2) {
        cartData.pop();
        serchData.pop();
      }

      cartData.push(cartItem);
      serchData.push(
        this.commonService.getData(this.appConfig.plan.filterSessionName)
      );

      /* SORT CART DATA BY DEPARTURE DATE */
      this.sortCartItems(cartData, serchData);

      this.commonService.setData(this.appConfig.cart.cartSessionName, cartData);
      this.commonService.setData(
        this.appConfig.cart.serchSessionName,
        serchData
      );
    }
  }

  updateCart(cartItem: any, index: number) {
    if (cartItem) {
      let cartData: any = this.commonService.getData(
        this.appConfig.cart.cartSessionName
      );
      let serchData: any = this.commonService.getData(
        this.appConfig.cart.serchSessionName
      );

      if (cartData && cartData[index]) {
        cartData[index] = cartItem;
      } else {
        cartData = [];
        cartData.push(cartItem);
        serchData = [];
      }
      serchData.push(
        this.commonService.getData(this.appConfig.plan.filterSessionName)
      );

      /* SORT CART DATA BY DEPARTURE DATE */
      this.sortCartItems(cartData, serchData);

      this.commonService.setData(this.appConfig.cart.cartSessionName, cartData);
    }
  }

  removeItem(index: number) {
    let cartData: any = this.commonService.getData(
      this.appConfig.cart.cartSessionName
    );
    let serchData: any = this.commonService.getData(
      this.appConfig.cart.serchSessionName
    );
    if (cartData && cartData[index]) {
      cartData.splice(index, 1);
      serchData.splice(index, 1);
    }
    this.commonService.setData(this.appConfig.cart.cartSessionName, cartData);
    this.commonService.setData(this.appConfig.cart.serchSessionName, serchData);
  }

  getCartData() {
    return this.commonService.getData(this.appConfig.cart.cartSessionName);
  }

  getSerchData() {
    return this.commonService.getData(this.appConfig.cart.serchSessionName);
  }

  async renewCartData() {
    let cartData = this.commonService.getData(
      this.appConfig.cart.cartSessionName
    );

    let serchData = this.commonService.getData(
      this.appConfig.cart.serchSessionName
    );

    if (!this._.isEmpty(cartData)) {
      /* DISCARD OLD PLANS (OLDER THAN 4 HOURS) */
      for (let i = cartData.length - 1; i >= 0; i--) {
        if (
          cartData[i].createdAt + this.appConfig.cache.ttl.cartItem <
          new Date().getTime()
        ) {
          cartData.splice(i, 1);
          serchData.splice(i, 1);
        }
        /* END */
      }

      /* RENEW PLAN DETAIL */
      for (let i = cartData.length - 1; i >= 0; i--) {
        let thePlan = await this.planService.getPlanDetail(
          cartData[i].plan.plan_code,
          cartData[i].targetDay,
          'cart'
        );
        /* UPDATE PLAN */
        if (thePlan.source_id == this.appConfig.plan.sources.kobo) {
          const departureCode =
            thePlan.station_list[cartData[i].departure].station_code;
          const destinationId =
            thePlan.station_list[cartData[i].destination].station_id;

          const data = await this.planService.getKoboFareData({
            plan_code: cartData[i].planCode,
            target_day: cartData[i].targetDay,
            dpt_station_code: departureCode,
            dst_station_code: destinationId,
          });
          cartData[i].koboFareData = data;
          if (Object.keys(data).length > 0) {
            thePlan.price = data.price.price;
            thePlan.price_child = data.price.price_child;
          }
        }

        cartData[i].plan = { ...cartData[i].plan, ...thePlan };

        serchData[i] = this.commonService.getData(
          this.appConfig.plan.filterSessionName
        );
        /* END */

        /* RECOUNT TOTAL */
        if (this.planService.calculateTotal(cartData[i]) === false) {
          cartData.splice(i, 1);
          serchData.splice(i, 1);
        }
      }

      /* SAVE CHANGES */
      this.commonService.setData(this.appConfig.cart.cartSessionName, cartData);
    }

    return cartData;
  }

  sortCartItems(cartData: any, serchData: any) {
    if (!this._.isEmpty(cartData) && cartData.length > 1) {
      if (
        this.moment(cartData[1].targetDay).valueOf() <
        this.moment(cartData[0].targetDay).valueOf()
      ) {
        let item1 = cartData[0];
        let item2 = cartData[1];
        let serch_item1 = serchData[0];
        let serch_item2 = serchData[1];

        cartData[0] = item2;
        cartData[1] = item1;
        serchData[0] = serch_item2;
        serchData[1] = serch_item1;
      }
    }
  }

  isEmpty() {
    if (this._.isEmpty(this.getCartData())) {
      return true;
    }
    return false;
  }
}
